import { ElMessage } from "element-plus"
import { goBackAppHomePage } from "@/utils/android"

// 响应成功拦截器
export const responseSuccessHandler = (response) => {
	// 检查是否有自定义响应处理器
	if (response.config.customHandler) {
		return response.config.customHandler(response)
	}

	const { code, msg, data } = response.data

	// 成功状态码为0
	if (Number(code) === 0) {
		return data
	}
	// 处理特定错误码
	switch (Number(code)) {
		case 401:
			// 未授权，token失效
			ElMessage.error(msg || "Token expired")
			setTimeout(() => {
				goBackAppHomePage()
			}, 2000)
			break
		case 403:
			// 权限不足
			ElMessage.error(msg || "Permission denied")
			break
		case 404:
			// 资源不存在
			ElMessage.error(msg || "Resource not found")
			break
		case 500:
			// 服务器错误
			ElMessage.error(msg || "Server error")
			break
		default:
			// 其他错误
			ElMessage.error(msg || "Request failed")
	}

	// 返回错误信息
	return Promise.reject(new Error(msg || "Request failed"))
}

// 响应失败拦截器
export const responseErrorHandler = (error) => {
	if (error.response) {
		// 请求已发出，但服务器响应状态码不在 2xx 范围内
		const { status, data } = error.response
		switch (status) {
			case 401:
				ElMessage.error("Unauthorized, please login again")
				setTimeout(() => {
					goBackAppHomePage()
				}, 2000)
				break
			case 403:
				ElMessage.error("Access forbidden")
				break
			case 404:
				ElMessage.error("API not found")
				break
			case 500:
				ElMessage.error("Server error")
				break
			default:
				ElMessage.error(data?.message || "Network error")
		}
	} else if (error.request) {
		// 请求已发出，但没有收到响应
		if (error.code === "ECONNABORTED") {
			ElMessage.error("Request timeout")
		} else {
			ElMessage.error("Network error, please try again")
		}
	} else {
		// 请求配置出错
		ElMessage.error("Request error")
	}

	return Promise.reject(error)
}
